<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pricing.country.details.bulkEdit.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row mb-3">
      <div class="col-12 col-md-3">
        <label class="label mb-1">
          {{ 'pricing.country.details.bulkEdit.priceType' | translate }}
        </label>
        <app-select
          #priceTypeSelect
          class="d-block"
          data-cy="country-bulk-price-type-select"
          [selected]="priceType()"
          (changed)="onPriceTypeChange($event)"
        >
          @for (type of priceTypes; track type) {
            <app-select-option
              [label]="'pricing.country.priceTypes.' + type | translate"
              [value]="type"
            />
          }
        </app-select>
      </div>
      <div class="col-12 col-md-4">
        <label class="label mb-1" for="countryBulkValidFrom">
          {{ 'pricing.country.details.bulkEdit.validFrom' | translate }}
        </label>
        <input
          #validFromDatepicker="ngbDatepicker"
          ngbDatepicker
          id="countryBulkValidFrom"
          class="form-control"
          container="body"
          data-cy="country-bulk-valid-from"
          [formField]="priceForm.validFrom"
          [readonly]="true"
          [minDate]="momentToNgbDate(minDate)"
          [maxDate]="momentToNgbDate(maxDate)"
          [startDate]="momentToNgbDate(startDate)"
          [placeholder]="'serviceData.form.placeholders.dateFormat' | translate"
          (click)="validFromDatepicker.toggle()"
        />
      </div>
      <div class="col-12 col-md-5">
        <label class="label mb-1" for="countryBulkCopyFrom">
          {{ 'pricing.country.details.bulkEdit.copyFromCountry' | translate }}
        </label>
        <input
          id="countryBulkCopyFrom"
          type="text"
          class="form-control"
          container="body"
          data-cy="country-bulk-copy-from-country"
          [ngbTypeahead]="searchCountries"
          [inputFormatter]="countryFormatter"
          [resultFormatter]="countryFormatter"
          [editable]="false"
          [(ngModel)]="copyFromCountry"
          [disabled]="copyingFromCountry() || !rows().length"
          [placeholder]="
            'pricing.country.details.bulkEdit.copyFromCountryPlaceholder'
              | translate
          "
          (selectItem)="onCopyCountrySelected($event)"
        />
      </div>
    </div>
    <div class="notes mb-3">
      {{ 'pricing.country.details.bulkEdit.firstPriceHint' | translate }}
    </div>
    @if (!rows().length) {
      <div class="notes">
        {{
          'pricing.country.details.bulkEdit.empty'
            | translate: { type: priceType() }
        }}
      </div>
    } @else {
      <div class="table-responsive">
        <table class="table table-sm align-middle">
          <thead>
            <tr>
              <th scope="col">
                {{ 'pricing.country.details.bulkEdit.bundle' | translate }}
              </th>
              <th scope="col" class="text-end">
                {{
                  'pricing.country.details.bulkEdit.currentPrice'
                    | translate: { type: priceType() }
                }}
              </th>
              <th scope="col" class="price-cell">
                {{
                  'pricing.country.details.bulkEdit.newPrice'
                    | translate: { type: priceType() }
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (
              row of rows();
              track priceType() + row.bundleId;
              let i = $index
            ) {
              <tr>
                <td>{{ row.name }}</td>
                <td class="text-end">
                  @if (row.currentPrice !== null) {
                    {{ row.currentPrice | number: '1.2-2' }}
                    {{ pricingCountry()?.currency }}
                  } @else {
                    <span class="text-danger">{{
                      'pricing.country.details.missingPrice' | translate
                    }}</span>
                  }
                </td>
                <td class="price-cell">
                  <input
                    type="number"
                    step="any"
                    class="form-control form-control-sm text-end"
                    [formField]="priceForm.prices[i].price"
                    [placeholder]="
                      'pricing.country.details.placeholders.price' | translate
                    "
                    [attr.data-cy]="'country-bulk-price-input-' + row.bundleId"
                  />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button
      ngbAutofocus
      type="button"
      class="btn btn-clear"
      (click)="modalRef.close()"
      data-cy="close-btn"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="submitDisabled()"
      (click)="save()"
      data-cy="save-btn"
    >
      {{
        'pricing.country.details.bulkEdit.save'
          | translate: { type: priceType() }
      }}
    </button>
  </div>
</div>
